import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { updateBodyClasses } from './hooks/update-body-classes.js'
import { createDeferred } from '../page-reveal/reveal-controller.js'
import { Events } from '../events'

export const registerSwupHooks = (swup, ctx) => {
	const { componentsManager, eventBus, browser, scrollSmootherManager } = ctx

	swup.hooks.on(
		'content:replace',
		() => {
			const container = document.querySelector('#swup')
			componentsManager?.removeComponents(container)
			browser?.enableScroll()

			// destroy theme sections
			// ctx.themeSections?.destroy()

			// ctx.themeManager?.unregisterContext('page')
			// UiThemeManager.unregisterContext('page-ui')
		},
		{ before: true },
	)

	swup.hooks.on('content:replace', updateBodyClasses)

	swup.hooks.on(
		'content:replace',
		() => {
			const container = document.querySelector('#swup')

			// Reset to the top of the new page *before* any ScrollTrigger work. Swup core
			// does no scrolling and the ScrollSmoother/Lenis reset paths are disabled, so
			// without this the window is still at the previous page's scroll offset when
			// refresh() runs below — triggers above that offset would be treated as already
			// scrolled-past and fire immediately with the wrong state. The loader mask is
			// covering the screen here, so the instant jump is invisible. `behavior:
			// 'instant'` forces the jump even if `scroll-behavior: smooth` is ever set in
			// CSS — a smooth-animated reset would run into the refresh() below.
			window.scrollTo({ top: 0, left: 0, behavior: 'instant' })

			scrollSmootherManager?.recreate?.()

			componentsManager?.loadComponents(container, () => {
				const triggers = ScrollTrigger.getAll()

				if (triggers && triggers.length) {
					ScrollTrigger.sort()
					ScrollTrigger.refresh()
				}

				// Settle signal for the reveal controller: the new page's components are
				// mounted and pins are built, so the mask can now play its exit.
				ctx.componentsReady?.resolve()
			})

			//
			ctx.themeManager?.syncContextFromElement('page')
			ctx.themeSections?.initScrollTriggers()

			// ctx.themeSections?.destroy()
			// ctx.themeSections = new ThemeSections({ themeManager: ctx.themeManager })

			eventBus?.emit(Events.SWUP_CONTENT_REPLACE, {})
		},
		{ after: true },
	)

	swup.hooks.on('page:view', (visit) => {
		eventBus?.emit(Events.SWUP_PAGE_VIEW, visit)
		queueMicrotask(() => eventBus?.emit(Events.PAGE_READY, visit))
	})

	swup.hooks.on('visit:start', (visit) => {
		ctx.currentTransition = visit
		// Fresh per-visit deferred; resolved once the new page's components have mounted
		// (in the content:replace after-hook above). The `in` transition awaits this.
		ctx.componentsReady = createDeferred()
	})

	swup.hooks.on('link:self', (visit) => {
		eventBus?.emit(Events.SWUP_LINK_SELF, visit)
	})
}
